import { toast } from "sonner";

export interface ToastOptions {
  duration?: number;
  position?:
    | "top-left"
    | "top-center"
    | "top-right"
    | "bottom-left"
    | "bottom-center"
    | "bottom-right";
  expand?: boolean;
  description?: string;
  id?: string | number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export class ToastService {
  static success(message: string, options?: ToastOptions) {
    const baseOptions = {
      duration: options?.duration || 6000,
      position: options?.position || "top-right",
      description: options?.description,
      id: options?.id,
    };

    const finalOptions = options?.action
      ? { ...baseOptions, action: options.action }
      : baseOptions;

    return toast.success(message, finalOptions);
  }

  static error(message: string, options?: ToastOptions) {
    const baseOptions = {
      duration: options?.duration || 8000,
      position: options?.position || "top-right",
      description: options?.description,
      id: options?.id,
    };

    const finalOptions = options?.action
      ? { ...baseOptions, action: options.action }
      : baseOptions;

    return toast.error(message, finalOptions);
  }

  static warning(message: string, options?: ToastOptions) {
    const baseOptions = {
      duration: options?.duration || 6000,
      position: options?.position || "top-right",
      description: options?.description,
      id: options?.id,
    };

    const finalOptions = options?.action
      ? { ...baseOptions, action: options.action }
      : baseOptions;

    return toast.warning(message, finalOptions);
  }

  static info(message: string, options?: ToastOptions) {
    const baseOptions = {
      duration: options?.duration || 6000,
      position: options?.position || "top-right",
      description: options?.description,
      id: options?.id,
    };

    const finalOptions = options?.action
      ? { ...baseOptions, action: options.action }
      : baseOptions;

    return toast.info(message, finalOptions);
  }

  static loading(message: string, options?: ToastOptions) {
    return toast.loading(message, {
      duration: options?.duration || Infinity,
      position: options?.position || "top-right",
      description: options?.description,
      id: options?.id,
    });
  }

  /**
   * Dismisses a specific toast
   */
  static dismiss(toastId: string | number) {
    toast.dismiss(toastId);
  }

  /**
   * Dismisses all toasts
   */
  static dismissAll() {
    toast.dismiss();
  }
}

export default ToastService;
